module.exports = __webpack_public_path__ + "media/images/Icon-calendar-ec4ed2f6654cb2d9d3753eaa75dd6787.svg";